// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BEnh","textarea":"styles_textarea__1RVaA"};